/* global maplibregl */

Apt.fn.make('maps', {
	/**
	 * Initialize module
	 *
	 * @param {$} target
	 * @param {Object} options
	 * @returns {Object}
	 */
	init(target, options) {
		const scope = this;
		const priv = scope.$private;

		if (window.crawler || typeof maplibregl === 'undefined') {
			priv.unsupported(target);

			return scope;
		}

		if (scope.map) {
			return scope.position();
		}

		priv.working = true;

		priv.initMap(target, options);

		priv.filters = LS.filters.get();

		priv.stripFilters(priv.filters);

		return scope;
	},

	/**
	 * Update map data
	 */
	update() {
		const priv = this.$private;

		if (! priv.map) {
			return;
		}

		const filters = LS.filters.get();

		priv.stripFilters(filters);

		if ($.equals(priv.filters, filters)) {
			return;
		}

		priv.filters = filters;
		priv.layers = $.copy(priv.default.layers);

		priv.setRelations();
		priv.initTerritories();
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		this.$private.purge();
	}
}, {
	/**
	 * @private
	 */
	_construct() {
		const scope = this;

		scope.break = 8;

		scope.default = {
			bounds: [
				-124.80469, 25.32417,
				-66.97266, 49.03787
			],
			center: [
				-95.18223, 37.71207
			],
			zoom: {
				country: 3,
				locality: 10,
				postal_code: 12, // eslint-disable-line
				region: 7,
				territory: 6,
				subterritory: 8
			},
			minZoom: {
				locality: 8,
				region: 6,
				subterritory: 8,
				territory: 5
			},
			layers: {
				territories: {
					visible: [],
					groups: null
				},
				subterritories: {
					loaded: [],
					visible: [],
					groups: null
				},
				listings: []
			}
		};

		scope.overlays = {
			flood: {
				label: 'Flood plain',
				opacity: 0.6,
				tiles: 'https://enviroatlas.epa.gov/arcgis/rest/services/Supplemental/Estimated_floodplain_CONUS_WM/ImageServer/exportImage?f=image&bbox={bbox-epsg-3857}&imageSR=102100&f=image&format=png8&transparent=true&dpi=96'
			},
			hydro: {
				label: 'Water features',
				before: 'territories',
				maxzoom: 16,
				tiles: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSHydroCached/MapServer/tile/{z}/{y}/{x}'
			},
			public: {
				label: 'Public lands',
				opacity: 0.6,
				maxzoom: 13,
				tiles: 'https://services.arcgis.com/v01gqwM5QqNysAAi/ArcGIS/rest/services/PADUS3_0Manager_Type/MapServer/tile/{z}/{y}/{x}'
			}
		};

		scope.bases = {
			here: {
				label: 'HERE satellite',
				tiles: 'https://maps.geo.us-east-1.amazonaws.com/v2/tiles/raster.satellite/{z}/{x}/{y}?key=' + $.get('global.awsKey')
			},
			mapbox: {
				label: 'Mapbox satellite',
				tiles: 'https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}@2x.webp?access_token=' + $.get('global.mapboxKey')
			},
			esri: {
				label: 'ESRI satellite',
				tiles: 'https://maps.geo.us-east-1.amazonaws.com/maps/v0/maps/satellite-esri/tiles/{z}/{x}/{y}?key=' + $.get('global.awsKey')
			},
			naip: {
				label: 'NAIP satellite',
				tiles: 'https://api.mapbox.com/v4/mapbox.naip/{z}/{x}/{y}@2x.webp?access_token=' + $.get('global.mapboxKey'),
				minzoom: 12.5
			}
		};

		scope.empty = {
			type: 'FeatureCollection',
			features: []
		};

		scope.layers = $.copy(scope.default.layers);

		scope.setRelations();
	},

	/**
	 * Set location relation aliases
	 */
	setRelations() {
		const scope = this;

		scope.relation = {
			territories: scope.layers.territories, // eslint-disable-line
			subterritories: scope.layers.subterritories, // eslint-disable-line
			parcels: scope.layers.parcels // eslint-disable-line
		};
	},

	/**
	 * Setup new map
	 *
	 * @param {$} target
	 * @param {Object} options
	 */
	initMap(target, options) {
		const scope = this;
		const pub = scope.$public;
		const style = pub.getStyle();
		const loc = $.context('location', {});
		const position = pub.parsePosition();
		const center = position ? position.center : (
			options.center || loc.center || scope.default.center
		);
		const defaultZoom = scope.default.zoom[loc.type || 'country'];
		const zoom = position ? position.zoom : (
			options.zoom || (loc.bounds ?
				defaultZoom : (center ? 13.9 : defaultZoom + 0.5)
			)
		);
		const conf = $.extend(true, {
			basic: false,
			points: false,
			preview: false,
			reset: options.single,
			single: false,
			settings: {
				dragRotate: ! options.preview,
				fadeDuration: 0,
				bounds: (position || options.center) ? null : (
					loc.bounds ? loc.bounds : (
						loc.center ?
							null : scope.default.bounds
					)
				),
				center: center,
				zoom: zoom
			},
			style: style
		}, options);

		if (! $(target).length) {
			return;
		}

		conf.target = target;

		scope.uid = LS.util.uid();
		scope.location = loc.slug;

		scope.conf = conf;

		if (options.bounds) {
			conf.settings.bounds = pub.parseBounds(options.bounds);
		} else if (conf.settings.bounds) {
			conf.settings.bounds = pub.padBounds(
				conf.settings.bounds, true
			);
		}

		if (conf.single && conf.center) {
			conf.showPoints = true;

			if (conf.single !== 'hide') {
				scope.layers.listings = [{
					type: 'Feature',
					properties: {},
					geometry: {
						type: 'Point',
						coordinates: conf.center
					}
				}];
			}
		} else if (conf.points) {
			conf.showPoints = true;

			scope.layers.listings = conf.points;
		}

		if (position) {
			scope.position = position;
		}

		scope.createMap();
	},

	/**
	 * Create new map
	 */
	createMap() {
		const scope = this;
		const pub = scope.$public;
		const conf = scope.conf;

		if (! pub.supported()) {
			scope.unsupported(conf.target);

			return;
		}

		scope.create(conf.target, conf.settings, instance => {
			scope.instance = instance;
			pub.map = scope.map = instance.map;

			scope.working = false;

			pub.bind('map', 'error', e => {
				if (e.error && ! /(ajax|fetch|load|run)/i.test(e.error.message)) {
					LS.error.report('MapError', e.error);
				}
			});

			scope.addScale();

			// Enforce minimum zoom for locations
			if (scope.location && ! scope.position) {
				const min = scope.default.minZoom[$.context('location.type')];

				if (min && min > scope.map.getZoom()) {
					scope.map.jumpTo({
						center: conf.settings.bounds ?
							(new maplibregl.LngLatBounds(conf.settings.bounds)).getCenter() :
							conf.settings.center,
						zoom: min
					});
				}
			}

			if (! conf.showPoints) {
				scope.$parent.removeClass('-is-loading');
			}

			scope.initModel();

			pub.ready(() => {
				scope.setupMap();
			});
		});
	},

	/**
	 * Setup map data sources
	 */
	setupMap() {
		const scope = this;
		const pub = scope.$public;
		const conf = scope.conf;
		const single = conf.single;
		const build = ! single && ! conf.basic;

		if (! conf.showPoints) {
			scope.layers.listings = [];
		}

		scope.addSources();

		if (build) {
			scope.initTerritories();
		}

		scope.initMarkers();
		scope.initStyle();

		pub.ready(() => {
			if (conf.showPoints) {
				scope.addMarkers();

				if (! single) {
					scope.fitBounds(scope.layers.listings, {
						animate: false
					});

					scope.initial = {
						center: pub.getCenter(),
						zoom: pub.getZoom()
					};
				}

				scope.$parent.removeClass('-is-loading');
			}

			if (conf.ready) {
				conf.ready();
			}
		});

		if (build) {
			LS.util.idle([
				scope.bindHistory,
				scope.watchMove,
				scope.watchZoom
			], scope);
		}
	},

	/**
	 * Initialize map data sources
	 */
	addSources() {
		const scope = this;

		scope.addSource('points', {
			type: 'geojson',
			data: scope.empty
		});

		if (scope.conf.polygons) {
			scope.addSource('polygons', {
				type: 'geojson',
				data: scope.conf.polygons || scope.empty
			});

			scope.addLayer({
				id: 'polygons',
				type: 'line',
				source: 'polygons',
				minzoom: 14,
				paint: {
					'line-width': 2.5,
					'line-color': '#f2f9f5',
					'line-opacity': [
						'interpolate', ['linear'], ['zoom'],
						14, 0,
						14.1, 1
					]
				}
			});
		}
	},

	/**
	 * Fit map to feature boundaries
	 *
	 * @param {Array} points
	 * @param {Object} options
	 */
	fitBounds(points, options) {
		if (! points || ! points.length) {
			return;
		}

		const scope = this;
		const pub = scope.$public;
		const bounds = new maplibregl.LngLatBounds();

		points.forEach(feature => {
			bounds.extend(feature.geometry.coordinates);
		});

		pub.constrain(bounds, Object.assign({
			animate: true,
			maxZoom: 15,
			pad: true
		}, options));
	},

	/**
	 * Filter only unique features
	 *
	 * @param {Array} features
	 * @param {String} [key='$id']
	 * @returns {Array}
	 */
	getUnique(features, key) {
		const ids = [];

		return features.filter(el => {
			const id = key ?
				el.properties[key] : el.id;

			if (ids.includes(id)) {
				return false;
			}

			ids.push(id);

			return true;
		});
	},

	/**
	 * Render unsupported message
	 *
	 * @param {$} target
	 */
	unsupported(target) {
		$(target)
			.removeClass('-is-loading')
			.addClass('-is-disabled');
	}
});